
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _readyt6wiEmCsShwz9vto8iB_45OnXfXp7L6TlE_y2dlXssrJwMeta } from "/app/pages/_ready.vue?macro=true";
import { default as disabled0KhmbN8ESa5UeqsYG_Q_POTi_45WOs3um7TrzZslvwX5kMeta } from "/app/pages/disabled.vue?macro=true";
import { default as notfoundRX4gm93WVWBegUJy3SXLYDuMwpiFYKebgE_45P8wDAvYUMeta } from "/app/pages/notfound.vue?macro=true";
import { default as _91_46_46_46path_9314Xp3_45SvLpBLCxChZrcHCOli7R4v7eq3BMA1HW5y6B8Meta } from "/app/pages/[...path].vue?macro=true";
import { default as indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as logoutUYmNrqQPxD4I1VCtdubU9c7hV2MRnNYob53UvKtTNwsMeta } from "/app/pages/auth/logout.vue?macro=true";
import { default as indexPk1QTTrPkZy5DZZKS3LSYJddkOM92L5CbCvVjYbdvdQMeta } from "/app/pages/on-boarding/index.vue?macro=true";
export default [
  {
    name: "_ready___en",
    path: "/_ready",
    meta: _readyt6wiEmCsShwz9vto8iB_45OnXfXp7L6TlE_y2dlXssrJwMeta || {},
    component: () => import("/app/pages/_ready.vue")
  },
  {
    name: "disabled___en",
    path: "/disabled",
    meta: disabled0KhmbN8ESa5UeqsYG_Q_POTi_45WOs3um7TrzZslvwX5kMeta || {},
    component: () => import("/app/pages/disabled.vue")
  },
  {
    name: "notfound___en",
    path: "/notfound",
    meta: notfoundRX4gm93WVWBegUJy3SXLYDuMwpiFYKebgE_45P8wDAvYUMeta || {},
    component: () => import("/app/pages/notfound.vue")
  },
  {
    name: "path___en",
    path: "/:path(.*)*",
    meta: _91_46_46_46path_9314Xp3_45SvLpBLCxChZrcHCOli7R4v7eq3BMA1HW5y6B8Meta || {},
    component: () => import("/app/pages/[...path].vue")
  },
  {
    name: "auth___en",
    path: "/auth",
    meta: indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta || {},
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "auth-logout___en",
    path: "/auth/logout",
    meta: logoutUYmNrqQPxD4I1VCtdubU9c7hV2MRnNYob53UvKtTNwsMeta || {},
    component: () => import("/app/pages/auth/logout.vue")
  },
  {
    name: "on-boarding___en",
    path: "/on-boarding",
    meta: indexPk1QTTrPkZy5DZZKS3LSYJddkOM92L5CbCvVjYbdvdQMeta || {},
    component: () => import("/app/pages/on-boarding/index.vue")
  }
]